import { Flex } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { usePagePadding } from "components/layout/pagePadding";
import { useBoundStore } from "@/store";
import {
  SIDER_WIDTH,
  SIDER_COLLAPSED_WIDTH,
} from "components/layout/sider/styles";
import { useMemo } from "react";

export default function ToolbarWizard({
  children,
  isWizard = true,
}: Readonly<{
  children: React.ReactNode;
  isWizard?: boolean;
}>) {
  const { theme } = useAntTheme();
  // The fixed toolbar spans the content area: it cancels the page's left
  // padding and lines its content up with the page padding.
  const pagePadding = usePagePadding();
  const collapsed = useBoundStore((state) => state.sidebarCollapsed);
  const sidebarHovered = useBoundStore((state) => state.sidebarHovered);

  let width: string;
  if (sidebarHovered || collapsed) {
    width = `calc(100% - ${SIDER_COLLAPSED_WIDTH}px)`;
  } else {
    width = `calc(100% - ${SIDER_WIDTH}px)`;
  }

  const toolbarStyle = useMemo(() => {
    if (!isWizard) return undefined;
    return {
      position: "fixed" as const,
      bottom: 0,
      width,
      marginLeft: -pagePadding.left,
      padding: `12px ${pagePadding.right}px 12px ${pagePadding.left}px`,
      borderTop: `1px solid ${theme.colorBorderSecondary}`,
      backgroundColor: theme.colorWhite,
      zIndex: 1000,
    };
  }, [isWizard, theme, width, pagePadding]);

  return (
    <Flex
      align="center"
      justify="center"
      gap={theme.paddingLG}
      style={toolbarStyle}
    >
      {children}
    </Flex>
  );
}
